export default "__VITE_ASSET__c95b0545__"